/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import axios from "axios";
import API_BASE_URL from "./config";

export default function EmployeeTimesheet() {
  const [tracking, setTracking]     = useState(false);
  const [startTime, setStartTime]   = useState(null);
  const [elapsed, setElapsed]       = useState(0);
  const [records, setRecords]       = useState([]);
  const [driverName, setDriverName] = useState("");
  const [vehicleNo, setVehicleNo]   = useState("");
  const [search, setSearch]         = useState("");
  const [startDate, setStartDate]   = useState("");
  const [endDate, setEndDate]       = useState("");
  const [saveErr, setSaveErr]       = useState("");
  const [savingOk, setSavingOk]     = useState(false);
  const [loading, setLoading]       = useState(false);

  // Tick every second while tracking
  useEffect(() => {
    let interval;
    if (tracking) {
      interval = setInterval(() => setElapsed(e => e + 1), 1000);
    }
    return () => clearInterval(interval);
  }, [tracking]);

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/onboarding/timesheet`);
      setRecords(res.data || []);
    } catch (e) { setRecords([]); }
    setLoading(false);
  };

  useEffect(() => { fetchRecords(); }, []);

  const fmt = (secs) => {
    const h = Math.floor(secs / 3600).toString().padStart(2, "0");
    const m = Math.floor((secs % 3600) / 60).toString().padStart(2, "0");
    const s = (secs % 60).toString().padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  const handleStart = () => {
    if (!driverName.trim()) { setSaveErr("Enter driver name before starting."); return; }
    setSaveErr("");
    setStartTime(new Date());
    setElapsed(0);
    setTracking(true);
  };

  const handleStop = async () => {
    setTracking(false);
    const endTime = new Date();
    const totalMins = Math.round(elapsed / 60);
    setSaveErr("");
    try {
      await axios.post(`${API_BASE_URL}/onboarding/timesheet`, {
        driverName: driverName.trim(),
        vehicleNumber: vehicleNo.trim(),
        date: new Date().toISOString().split("T")[0],
        startTime: startTime?.toLocaleTimeString(),
        endTime: endTime.toLocaleTimeString(),
        totalHours: (elapsed / 3600).toFixed(2),
        totalMinutes: totalMins,
      });
      setSavingOk(true);
      setTimeout(() => setSavingOk(false), 3000);
      fetchRecords();
    } catch (e) {
      setSaveErr("Save failed — check backend connection.");
    }
    setElapsed(0);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this timesheet record?")) return;
    try {
      await axios.delete(`${API_BASE_URL}/onboarding/timesheet/${id}`);
      fetchRecords();
    } catch (e) { alert("Delete failed"); }
  };

  const filtered = records.filter(r => {
    const q = search.toLowerCase();
    const matchSearch = (r.driverName || "").toLowerCase().includes(q) ||
                        (r.vehicleNumber || "").toLowerCase().includes(q);
    const rDate = r.date ? new Date(r.date) : null;
    const matchStart = !startDate || (rDate && rDate >= new Date(startDate));
    const matchEnd   = !endDate   || (rDate && rDate <= new Date(endDate + "T23:59:59"));
    return matchSearch && matchStart && matchEnd;
  });

  const downloadCSV = () => {
    const h = "Driver Name,Vehicle,Date,Start Time,End Time,Total Hours,Total Minutes\n";
    const rows = filtered.map(r =>
      `${r.driverName},${r.vehicleNumber || ""},${r.date},${r.startTime},${r.endTime},${r.totalHours},${r.totalMinutes}`
    ).join("\n");
    const blob = new Blob([h + rows], { type: "text/csv" });
    const a = document.createElement("a"); a.href = URL.createObjectURL(blob);
    a.download = `timesheet_records.csv`; a.click();
  };

  const S = {
    container:  { fontFamily: "Arial, sans-serif", marginLeft: "270px", marginRight: "10px", backgroundColor: "#fff", color: "#000", minHeight: "100%", boxShadow: "0 4px 8px rgba(0,0,0,0.1)" },
    body:       { padding: "20px" },
    timerCard:  { background: "#fff", border: "2px solid #000", borderRadius: 10, padding: "20px 24px", marginBottom: 20, maxWidth: 560 },
    timerLbl:   { fontSize: 11, fontWeight: "bold", textTransform: "uppercase", letterSpacing: "0.08em", color: "#555", marginBottom: 4 },
    timerDisp:  { fontSize: 48, fontFamily: "monospace", fontWeight: "bold", color: "#000", letterSpacing: 2, margin: "10px 0" },
    timerActive:{ color: "#FFC107" },
    inputRow:   { display: "flex", gap: 10, marginBottom: 14, flexWrap: "wrap" },
    input:      { padding: "8px 10px", border: "1px solid black", borderRadius: 5, fontSize: 13 },
    btnYellow:  { background: "#FFC107", color: "#000", border: "none", padding: "10px 28px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 14 },
    btnBlack:   { background: "#000", color: "#fff", border: "none", padding: "10px 28px", borderRadius: 5, cursor: "pointer", fontWeight: "bold", fontSize: 14 },
    btnGrey:    { background: "#eee", color: "#555", border: "1px solid #ccc", padding: "10px 20px", borderRadius: 5, cursor: "pointer", fontSize: 14 },
    success:    { background: "#e6f9ee", border: "1px solid #27ae60", color: "#27ae60", padding: "8px 14px", borderRadius: 6, fontSize: 13, marginTop: 10 },
    errBox:     { background: "#fde8e8", border: "1px solid #c0392b", color: "#c0392b", padding: "8px 14px", borderRadius: 6, fontSize: 13, marginTop: 10 },
    toolbar:    { display: "flex", gap: 10, alignItems: "center", marginBottom: 14, flexWrap: "wrap" },
    table:      { width: "100%", borderCollapse: "collapse" },
    thB:        { background: "#000", color: "#fff", padding: "13px 12px", textAlign: "center", fontSize: 13, fontWeight: "bold" },
    td:         { border: "1px solid #ccc", padding: "10px 12px", textAlign: "center", fontSize: 13, color: "#000" },
    dot:        (active) => ({ display: "inline-block", width: 10, height: 10, borderRadius: "50%", background: active ? "#22c55e" : "#ccc", marginRight: 8, animation: active ? "pulse 1.2s infinite" : "none" }),
  };

  return (
    <div style={S.container}>
      <h2 className="sendo-heading">Employee Timesheet</h2>
      <div style={S.body}>

        {/* Timer Card */}
        <div style={S.timerCard}>
          <div style={S.timerLbl}>
            <span style={S.dot(tracking)} />
            {tracking ? "Shift In Progress" : "Ready to Start"}
          </div>

          <div style={{ ...S.timerDisp, ...(tracking ? S.timerActive : {}) }}>
            {fmt(elapsed)}
          </div>

          <div style={S.inputRow}>
            <div>
              <div style={{ fontSize: 11, fontWeight: "bold", marginBottom: 4 }}>Driver Name *</div>
              <input style={S.input} placeholder="Driver name..." value={driverName}
                onChange={e => setDriverName(e.target.value)} disabled={tracking} />
            </div>
            <div>
              <div style={{ fontSize: 11, fontWeight: "bold", marginBottom: 4 }}>Vehicle No.</div>
              <input style={S.input} placeholder="e.g. KA01AE8482" value={vehicleNo}
                onChange={e => setVehicleNo(e.target.value)} disabled={tracking} />
            </div>
          </div>

          <div style={{ display: "flex", gap: 10 }}>
            {!tracking ? (
              <button style={S.btnYellow} onClick={handleStart}>▶ Start Shift</button>
            ) : (
              <button style={S.btnBlack} onClick={handleStop}>■ Stop & Save</button>
            )}
            {!tracking && (
              <button style={S.btnGrey} onClick={() => { setDriverName(""); setVehicleNo(""); setElapsed(0); setSaveErr(""); setSavingOk(false); }}>
                Clear
              </button>
            )}
          </div>

          {savingOk && <div style={S.success}>✅ Timesheet saved successfully!</div>}
          {saveErr  && <div style={S.errBox}>{saveErr}</div>}
        </div>

        {/* Records Table */}
        <div style={S.toolbar}>
          <input style={S.input} placeholder="Search driver or vehicle..." value={search} onChange={e => setSearch(e.target.value)} />
          <input style={S.input} type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
          <input style={S.input} type="date" value={endDate}   onChange={e => setEndDate(e.target.value)} />
          <button style={{ ...S.btnYellow, padding: "8px 16px" }} onClick={downloadCSV}>⬇ Download</button>
          <span style={{ fontSize: 13, color: "#555" }}>{filtered.length} records</span>
        </div>

        {loading ? (
          <p>Loading timesheet records...</p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={S.table}>
              <thead>
                <tr>
                  {["#","Driver Name","Vehicle","Date","Start Time","End Time","Total Hours","Total Mins","Action"].map(h => (
                    <th key={h} style={S.thB}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={9} style={{ ...S.td, color: "#888" }}>No records found</td></tr>
                ) : filtered.map((r, i) => (
                  <tr key={r._id} style={{ background: i % 2 === 0 ? "#fff" : "#fafafa" }}>
                    <td style={S.td}>{i + 1}</td>
                    <td style={S.td}><strong>{r.driverName}</strong></td>
                    <td style={S.td}>{r.vehicleNumber || "—"}</td>
                    <td style={S.td}>{r.date ? new Date(r.date).toLocaleDateString("en-GB") : "—"}</td>
                    <td style={S.td}>{r.startTime}</td>
                    <td style={S.td}>{r.endTime}</td>
                    <td style={S.td}><strong>{r.totalHours} h</strong></td>
                    <td style={S.td}>{r.totalMinutes} min</td>
                    <td style={S.td}>
                      <button
                        style={{ background: "#fde8e8", border: "1px solid #c0392b", color: "#c0392b", padding: "4px 10px", borderRadius: 5, cursor: "pointer", fontSize: 12 }}
                        onClick={() => handleDelete(r._id)}>
                        🗑 Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Pulse animation for timer dot */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.3); }
        }
      `}</style>
    </div>
  );
}
